export default {
    "variables": {
        "event": {
            "value": "api_payment",
            "type": "String"
        },
        "merchantId": {
            "value": "",
            "type": "String"
        },
        "content": {
            "value": "",
            "type": "Json",

        },
        "charge_at": {
            "value": "",
            "type": "String"
        },
        "apiKey": {
            "value": "",
            "type": "String",
        },
        "app_id": {
            "value": "",
            "type": "String"
        },
    }
};
